<template>
<!-- 登录页 -->
  <div class="mainbox">
       <Head :logo='logo'></Head>
       <van-form>
            <van-field
                v-model="loginForm.userName"
                name="用户名"
                label="用户名"
                label-class='formTitle'
                placeholder="请输入用户名"
            />
            <van-field
                v-model="loginForm.password"
                type="password"
                name="密码"
                label="密码"
                label-class='formTitle'
                placeholder="请输入密码"
            />
            <div class="code">
                <van-field
                    v-model="loginForm.captcha"
                    center
                    clearable
                    label="验证码"
                    label-class='formTitle'
                    placeholder="请输入验证码"
                    />
                <img
                    id="captcha"
                    :src="imageCode"
                    @click="getCaptcha()"
                />
            </div>
        </van-form>
        <van-button round block type="info" native-type="submit" @click="onSubmit" class="btn">登录</van-button>
        <PrivacyDialog merchant='1' @getReadState='getReadState'></PrivacyDialog>

       <Foot  v-if='list && list.bottomMessage && list.bottomMessage.length>0' :list='list'></Foot>
  </div>
</template>

<script>
    import Head from '@/components/head'
    import Foot from '@/components/foot'
    import { Dialog } from 'vant';
    import { setToken,savePrivacy} from "@/utils/common";
    import { Notify,Toast } from 'vant';
    import {judgeVde} from "@/utils/publicJudge";
    import PrivacyDialog from '@/components/dialog/privacyDialog'

    var crypto = require('crypto');
export default {
    name: 'login',
    components: {
        Head,
        Foot,
        PrivacyDialog
    },
    data() {
        return {
            vde:'',
            logo:'',
            list:[],
            imageCode:'',
            publicKey: "",
            loginForm: {
                userName: "",
                password: "",
                userName: "",
                password: "",
                captchaKey: "",
                captcha: "",
                keyId: ""
            },   
            fromtype:'',//1 跳停车收费 2 融资担保
            isRead:false,
            details:[],
         }
    },
     created() {
            if (this.$route.query.vde === undefined) {
                this.vde = ''
            }else {
                this.vde = this.$route.query.vde
            }
            this.fromtype = this.$route.query.fromtype?this.$route.query.fromtype:'';
            localStorage.setItem('vde',this.vde);
            // fromtype == 1 路边停车
            localStorage.setItem('loginFromType',this.fromtype);
            //判断vde
            judgeVde({vde:this.vde},this);
            this.getLock();
            this.getHeadImg()
            this.getFootData()
            this.getCaptcha();
            this.initKey();
        },
    methods:{
            // 勾选隐私
            getReadState(isRead,details) {
                this.isRead = isRead;
                this.details = details;
            },
            getLock() {
                let data={
                    deptId:this.vde,
                    type:this.fromtype=='1'?9:this.fromtype=='2'?10:3 //同获取底部信息type 不一样
                }
                this.request({
                    url:'/specialPay/isEnableSpecialPay',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code!=1000) {
                         Dialog.alert({
                            title: '提示',
                            message: res.data.message,
                        }).then(() => {
                             this.$router.push({path:'/404'})
                        });
                    }
                })
            },
            getHeadImg() {
                let data = {}
                data.vde = this.vde
                this.request({
                    url:'/webPortal/websitConfig',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code == 1000 && res.data.result) {
                        if(res.data.result.logoUrlLogin) {
                            this.logo = res.data.result.logoUrlLogin;
                        }else {
                            this.logo = require("@/assets/img/logo.png");
                        }
                        sessionStorage.setItem('logoImg',this.logo)
                        sessionStorage.setItem('title',res.data.result.websitTitle)
                         document.title = sessionStorage.getItem('title');
                    }else if (res.data.code != 1000){
                        this.$router.push({ path: "/404" });
                    }
                })
            },
      	// 获取底部数据
             getFootData() {
                let data = {
                    vde:this.vde,
                    type:this.fromtype=='2'?'12':this.fromtype=='1'?'10':'2'
                }
                this.request({
                    url:'/systemManage/mobileGetMessage',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code != 1000) {
                        this.list=res.data.result
                        sessionStorage.setItem('footList',JSON.stringify(this.list))
                    }else {
                    }
                })
            },
            // 图片验证码
            getCaptcha() {
                this.request({
                    url:'/sso/captcha',
                    method:'get',
                }).then((res)=>{
                    if (res.data.code==1000) {
                        this.imageCode = res.data.result.image;
                        this.loginForm.captchaKey = res.data.result.captchaKey;
                    }
                })
            },
            // 加密key
            initKey() {
                this.request({
                    url:'/sso/initKey',
                    method:'get'
                }).then((res)=>{
                    if (res.data.code === 1000) {
                        this.loginForm.keyId = res.data.result.keyId;
                        this.publicKey = res.data.result.publicKey;
                    }
                })
            },
             encrypt(publicKey, data) {
                //使用公钥加密
                let publicKeyStr = '-----BEGIN PUBLIC KEY-----\n' +publicKey+
                '\n' +
                '-----END PUBLIC KEY-----';

                let  encryptStr = crypto.publicEncrypt({key:publicKeyStr, padding: crypto.constants.RSA_PKCS1_PADDING}, Buffer.from(data, 'utf8'));
                let encrypted = encryptStr.toString('base64')
                return encrypted;
            },
             onSubmit() {
                  if (this.isRead == false) {
                    Dialog.alert({
                    title: "提示",
                    message: "请先阅读《商户服务协议》",
                    }).then(() => {});
                    return;
                }
                 if (this.loginForm.userName=='') {
                      Dialog.alert({
                        title: '提示',
                        message: '请填写用户名',
                    }).then(() => {
                    });
                 }else if (this.loginForm.password=='') {
                     Dialog.alert({
                        title: '提示',
                        message: '请填写密码',
                    }).then(() => {
                    });
                 }else if (this.loginForm.captcha=='') {
                    Dialog.alert({
                        title: '提示',
                        message: '请填写验证码',
                    }).then(() => {
                    });
                 }else {
                     setToken('')
                     let data = {
                         userName: this.loginForm.userName.trim(),
                         password: this.encrypt(this.publicKey, this.loginForm.password),
                         captcha: this.loginForm.captcha,
                         captchaKey: this.loginForm.captchaKey,
                         keyId: this.loginForm.keyId,
                        device:'mobile'
                     }
                     if (this.vde) {
                         data.vde = this.vde
                     }
                     Toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    });
                     this.request({
                         url:'/sso/login',
                         method:'post',
                         data:data
                     }).then((res)=>{
                          Toast.clear()
                         if (res.data.code == 1000) {
                             setToken(res.data.result.token);
                                 this.getAuth().then((result)=>{
                                     if (result) {
                                         if (this.fromtype == '1') {
                                             this.$router.push({ path: "/parkingEntry?vde="+this.vde }); //路边停车
                                         }else if (this.fromtype == '2') {
                                             this.$router.push({ path: "/financing?vde="+this.vde }); //融资担保
                                         }else {
                                             this.$router.push({ path: "/loginIndex?vde="+this.vde }); //上门收费
                                         }
                                        
                                     }
                                 });
                                this.savePrivacy(res.data.result.identify);
                         }else if (res.data.code == 2006) {
                              this.initKey();
                              this.onSubmit();
                         }else {
                             Notify({ type: 'danger', message: res.data.message });
                             this.getCaptcha();
                         }

                     }).catch(error => {
                              this.getCaptcha();
                          });
                 }
             },
            getAuth() {
              return  this.request({
                    url:'/user/getAuth',
                    method:'get',
                    }).then((res)=>{
                        if (res.data.code == 1000) {
                            sessionStorage.setItem('user',JSON.stringify(res.data.result.user));  
                            return true;                      
                        }                
                    })
        
            },
                    // 存储隐私授权接口
            savePrivacy(identify) {
                if (identify) {
                    let savePrivacyData = {   
                        details:this.details,
                        userId: this.loginForm.userName,
                        userName:identify
                    };
                    savePrivacy(savePrivacyData);
                }
            },
        }
}
</script>

<style lang='scss' scoped>
    .mainbox {
        padding: 0 2vw;
        box-sizing: border-box;
        .btn {
            margin-top: 30px !important;
        }
        .van-form {
            background:rgba(255,255,255,1);
            box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
            border-radius:5px;
        }
        .van-cell {
            background: transparent;
        }
        .formTitle {
            padding-right: 40px;
            text-align-last: justify;
        }
        .code {
            overflow: hidden;
            white-space: nowrap;
            .van-cell {
                width: 60% !important;
                float: left;
            }
            img {
                width:112px;
                height: 44px;
                float: right;
            }
        }
        .van-dialog__message {
            font-size: 15px !important;
            padding: 15px 10px !important;
        }
    }
</style>